import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADCertTemplate entity - alias of ADObject
 * Represents Active Directory Certificate Template objects
 */
export const adCertTemplateEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADCertTemplate', display: 'AD Cert Template' },
  alias: 'ADObject',
};
